import React from 'react'
import { withIcon } from '../../withIcon'

function EyeHideSolidIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24">
      <path d="M19.3262 4.02992C19.7091 3.64857 20.33 3.64857 20.7129 4.02992C21.0957 4.41127 21.0957 5.02946 20.7129 5.41078L6.09473 19.9704C5.71183 20.3516 5.09085 20.3517 4.70801 19.9704C4.32528 19.5891 4.32542 18.9708 4.70801 18.5895L6.79102 16.5133C4.19536 14.7566 3.01574 12.1778 3 12.1432C3.01949 12.1119 6.72041 6.1725 12 6.1725C13.4911 6.17251 14.8493 6.63819 16.0342 7.30824L19.3262 4.02992ZM18.5059 9.15981C20.0793 10.6452 20.9917 12.1296 21 12.1432C20.9765 12.196 18.3243 18.1139 12 18.1139C11.2818 18.1139 10.6104 18.0356 9.98438 17.8981L11.8945 15.9391C11.9296 15.9401 11.9647 15.942 12 15.942C14.0645 15.942 15.7049 14.2598 15.7051 12.1432C15.7051 12.1071 15.7031 12.0707 15.7021 12.0348L18.5059 9.15981ZM12 8.34438C9.93544 8.34438 8.29502 10.0265 8.29492 12.1432C8.29501 12.9674 8.54497 13.7248 8.9707 14.3434L10.5391 12.7809C10.4577 12.585 10.4122 12.3696 10.4121 12.1432C10.4122 11.2436 11.1228 10.5153 12 10.5153C12.2373 10.5153 12.462 10.569 12.6641 10.6647L14.2324 9.10219C13.614 8.62592 12.843 8.34438 12 8.34438Z" fill={color}/>
    </svg>
  )
}

export default withIcon(EyeHideSolidIcon)
